import newRelic from './newRelic';

export default function trackNewRelicPageViewName(pageViewName) {
  // noinspection JSUnresolvedFunction
  newRelic.setPageViewName(pageViewName);
}
